var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTranslationCreated = function SvgTranslationCreated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#87AACA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.165 12h-1.4v-1.4a.7.7 0 1 0-1.4 0V12h-1.4a.7.7 0 0 0 0 1.4h1.4v1.4a.7.7 0 0 0 1.4 0v-1.4h1.4a.7.7 0 1 0 0-1.4Zm3.295-3.296-2.8-2.8a.697.697 0 0 0-.495-.205h-5.6c-1.157 0-2.1.942-2.1 2.1v8.4c0 1.158.943 2.1 2.1 2.1h7c1.158 0 2.1-.942 2.1-2.1v-7a.696.696 0 0 0-.205-.495ZM15.565 16.9h-7a.7.7 0 0 1-.7-.7V7.8a.7.7 0 0 1 .7-.7h4.9c.449 0 .878.178 1.195.495l1.11 1.11c.317.317.495.747.495 1.195v6.3a.7.7 0 0 1-.7.7Z"
  })));
};
export default SvgTranslationCreated;